module.exports = __webpack_public_path__ + "static/media/ticket.1cb7b5c1.png";